import * as os from 'os'

const configs = {
    baseUrl: window._env_.REACT_APP_API_URL || 'http://localhost:5000/api',
}

export default configs
